export default {
    showPartialPaymentInformationPopup({ commit }) {
        commit("togglePartialPaymentInformationPopup", true);
    },
    hidePartialPaymentInformationPopup({ commit }) {
        commit("togglePartialPaymentInformationPopup", false);
    },
};
